import { render, staticRenderFns } from "./presentationCredits.vue?vue&type=template&id=8b01dbc0&scoped=true&lang=pug&"
import script from "./presentationCredits.vue?vue&type=script&lang=js&"
export * from "./presentationCredits.vue?vue&type=script&lang=js&"
import style0 from "./presentationCredits.vue?vue&type=style&index=0&id=8b01dbc0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b01dbc0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
